export default {
  api: process.env.REACT_APP_API,
  formHandlerEndpoint: process.env.REACT_APP_FORM_HANDLER_ENDPOINT,
  socket: process.env.REACT_APP_SOCKET,
  payjpKey: process.env.REACT_APP_PAYJP_KEY,
  basename: process.env.REACT_APP_BASENAME,
  gaPropertyId: process.env.REACT_APP_GA_PROPERTY_ID,
  facebookPixelId: process.env.REACT_APP_FACEBOOK_PIXEL_ID,
  chatroomChannel: 'FindmeChatroomChannel',
  terms: 'findme/terms',
  customers: 'findme/customers',
  login: 'findme/customers/login',
  logout: 'findme/customers/logout',
  prefectures: 'doctors/prefectures',
  addresses: 'findme/medical_municipalities',
  requests: 'findme/requests',
  searchHospital: 'findme/hospitals?word=',
  chatrooms: 'findme/chatrooms',
  messages: 'findme/messages',
  consultationOptions: 'findme/settings/consultation_options',
  files: 'findme/files',
  files_presigned: 'findme/files/presigned_upload',
  proposals: 'findme/proposals',
  payjpInfo: 'findme/settings/token_info?token=',
  annotationPrice: 'findme/settings/payment_amount?payment_type=annotation&request_id=',
  settings: 'findme/settings',
  payments: 'findme/payments',
  annotations: 'findme/annotations',
  doctors: 'findme/doctors',
  notifications: 'findme/notifications',
  resetPassword: 'findme/reset_password',
  resetAflacPassword: 'findme/aflac/reset_password',
  prices: 'findme/settings/price',

  client_completed_findme_customer_request_directory_upload_path: ({requestId, directoryUploadId}) =>
    `findme/customer/requests/${requestId}/directory_uploads/${directoryUploadId}/client_completed`,

  directory_uploads_path: ({requestId}) => `findme/customer/requests/${requestId}/directory_uploads`,
  directory_upload_path: ({requestId, directoryUploadId}) =>
    `findme/customer/requests/${requestId}/directory_uploads/${directoryUploadId}`,
}



// WEBPACK FOOTER //
// ./src/modules/config.js